<app-invoice-table-filter></app-invoice-table-filter>

<div class="content-spacer">
    <app-invoice-table></app-invoice-table>
</div>
